import React, {useState} from 'react'
import styled from "@emotion/styled/macro"
import { theme } from './Theme'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import SvgRightArrowMenu from '../images/SVGs/RightArrowMenu'
import SvgDownArrowMenu from '../images/SVGs/DownArrowMenu'
import SvgMegaMenuButton1Background from '../images/SVGs/MegaMenuButton1Background'
import SvgMegaMenuButton2Background from '../images/SVGs/MegaMenuButton2Background'
import SvgRightArrow from '../images/SVGs/RightArrow'
import { CustomModal } from './CustomModal'
import { Form } from './Form'


const PopupButton = (props) =>{
  const [isModalOpen, setIsModalOpen] = useState(false)
  return(
      <>
<button 
          className='megaMenuButtonContainer'
          onClick={() => setIsModalOpen(true)}
          >
            <SvgMegaMenuButton1Background />
            <div className="textArrowContainer">
            <p>
            {props.buttonText}
            </p>
            <SvgRightArrow />
            </div>
          </button>
          <CustomModal onClose={() => setIsModalOpen(false)} isModalOpen={isModalOpen} modalContent={<Form data={props.formData} />} />
</>
  )
}

const ThirdLevel = (props) =>{
  const thirdLevel = props.thirdLevel
  return(
<li key={'thirdLevel'+thirdLevel.index}>
       <Link to={thirdLevel.path}>
       {thirdLevel.label}
       </Link>
             </li>
  )
}
const SecondLevel = (props) => {
  
  
  const [thirdLevelVisible, setThirdLevelVisible] = useState(true);
  const toggleThirdLevelVisible = (key) => {
    setThirdLevelVisible((prev) =>
      Boolean(!prev[key]) ? { ...prev, [key]: true } : { ...prev, [key]: false }
    );
  };


  const item = props.item

  const GatsbyImageStyled = styled(GatsbyImage)`
  transition: none;
pointer-events: none;
  `
  
  return(
    
<div className="secondLevel">
         
<ul className='secondLevelInnerContainer'>
         <li className='imageHolder' key="gatsbyImageContainerNoTransition"> 
         <GatsbyImageStyled image={props.dropdownImages[item.index].image} alt={props.dropdownImages[item.index].altText} loading="eager" />
                
                    
         </li>
       
         
             <ul className='secondLevelLinksContainer'>
           {item.secondLevel.map(secondLevel =>{
             return(
          
       <li 
       key={'secondLevel'+secondLevel.index}
       onMouseEnter={() => toggleThirdLevelVisible(secondLevel.id)} onMouseLeave={() => setThirdLevelVisible(false)}
       >
         <div className='linkArrowHolder'>
         <Link to={secondLevel.path}>
       {secondLevel.label}
       </Link>
       {secondLevel.thirdLevel !== 0 &&
       <button className="rightArrow">
         
{thirdLevelVisible[secondLevel.id] ? 
  <SvgDownArrowMenu />
  :
<SvgRightArrowMenu />
}
         
       </button>
           }
         </div>
       
       {thirdLevelVisible[secondLevel.id] === true &&
       secondLevel.thirdLevel !== 0 &&
       <ul className="thirdLevel">
         {secondLevel.thirdLevel.map((thirdLevel, index) =>{
           return(
             <ThirdLevel key={index} thirdLevel={thirdLevel} />
           )
         })}
       </ul>
       }
       </li>
             )
           })}
           </ul>
           
      <ul>
        <li>
          <PopupButton megaMenuButtons={props.megaMenuButtons} formData={props.formData} buttonText={props.buttonText} />
        </li>
        <li>
          <Link className='megaMenuButtonContainer' to={props.megaMenuButtons.secondButtonLink}>
          <SvgMegaMenuButton2Background />
          <div className="textArrowContainer">
            <p>
            {props.megaMenuButtons.secondButtonText}
            </p>
            <SvgRightArrow />
            </div>
          </Link>
        
        
        </li>
      </ul>
      
        
         </ul>
        
       </div>
       
  )
}

const MainMenu = (props) =>{
  const [isHovered, setIsHovered] = useState(false);
  


const item = props.item 
  return(
    <li 
        className='topLevelItems'
        key={'topLevelItems'+item.index}
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)}
        >
      <Link to={item.path}>
      <span>{item.label}</span>
      </Link>
      {isHovered &&
      item.secondLevel !== 0 &&
      <SecondLevel dropdownImages={props.dropdownImages} item={item} megaMenuButtons={props.megaMenuButtons} formData={props.formData} buttonText={props.buttonText} />
      }
        </li>
  )
 
}
const NavDesktop = (props) =>{
    const MainMenuContainer = styled.ul`
    grid-row: 2;
   grid-column: 2;
   background-color: ${theme.colors.gray};
   display: flex;
   align-items: stretch;
   padding-left: 2.875rem;
    text-transform: uppercase;
    font-size: clamp(0.75rem, 0.6590rem + 0.3883vw, 1.125rem);
    font-weight: 700;
   

   li{
     display: inline-block;
     margin: 0;
   }
   .topLevelItems:first-of-type{
       a{
        padding: 0 1.25rem 0 0;
       }
     
   }
   .topLevelItems:last-of-type{
       a{
        padding: 0 0 0 1.25rem;
       }
    
   }
   .topLevelItems{
     display: flex;
     align-items: stretch;
     
    a{
        padding: 0 1.25rem;
        min-width: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
   }
   a{
     color: ${theme.colors.body};
   }
   .secondLevel{
   position: absolute;
   width: 100%;
   top: 97%;
   left: 0;
   background-color: ${theme.colors.dark};
   z-index: 2;
 }
 .secondLevelInnerContainer{
    display: grid;
    grid-template-columns: 34% 45% 21%;
    max-width: 90.75rem;
  padding: 4.5625rem 2rem;
  margin: 0 auto;
  li{
  display: block;

}
   }
   .imageHolder{
  img{
    width: 100%;
      height: auto;
    }
   display: flex;
   align-items: stretch;
 }

 .secondLevelLinksContainer{
     column-count: 2;
     padding-inline-start: 0;

     li{
      break-inside: avoid;
     }
     a{
    color: ${theme.colors.light};
    display: inline-block;
    min-width: auto;
   }
   }
   .secondLevelLinksContainer:first-of-type{
     a{
      padding: 1em;
      transition: all 0.25s;
      &:hover{
        color: ${theme.colors.primary}
      }
     }
   }

.linkArrowHolder{
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.rightArrow{
  appearance: none;
  background-color: transparent;
  border: none;
}

.thirdLevel{
  background-color: ${theme.colors.primary};
a{
  width: 100%;
}
}
.thirdLevel:first-of-type{
  a{
    &:hover{
background-color: ${theme.colors.secondary};
color: ${theme.colors.light};
    }
  }
}
.megaMenuButtonContainer{
  position: relative;
  appearance: none;
  background-color: transparent;
  border: none;
  padding: 0;
  
  svg{
    max-width: 100%;
  }

  &:hover{
    cursor: pointer;
    .textArrowContainer{
      svg{
        transform: translateX(8px);
      }
    }
  }
}
a.megaMenuButtonContainer:first-of-type{
  
    padding: 0;
  
}
.textArrowContainer{
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  color: ${theme.colors.light};
  font-family: ${theme.fonts.altFont};
  font-weight: 700;
  letter-spacing: 1px;
  font-size: clamp(0.75rem, 0.6742rem + 0.3236vw, 1.0625rem);
  padding: 1.3125rem 1.75rem;
  box-sizing: border-box;
  svg{
    transition: all 0.25s;
  }
  
}
    `

      

    return(
        <MainMenuContainer>
        {props.mainMenuItems.map((item, index)=>{
          return(
      <MainMenu key={`main-menu-${index}`} item={item} dropdownImages={props.dropdownImages} megaMenuButtons={props.megaMenuButtons} formData={props.formData} buttonText={props.buttonText}/>
          )
        })}
      </MainMenuContainer> 
    )
}
export {NavDesktop}